import React from 'react';
import ReactDOM from 'react-dom';
import { AppContextProvider } from '../../../../../Services/AppContext';
import { loadDOMComponent } from '../../../../../helpers';
import { store } from '../../../../../store/store';
import { Provider } from 'react-redux';
import TherapistDetailButton from './TherapistDetailButton';

loadDOMComponent({
	selector: 'react-therapist-detail-button',
	callback: ({ container, context }: any) => {
		const userId = container.getAttribute('userId');

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<TherapistDetailButton userId={userId} />
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
